import { config } from '@/config.ts';

export interface SupportData {
	tg?: string;
	phone?: string;
	phoneText?: string;
	mail?: string;
	viber?: string;
}

type BrandSupportConfig = Record<string, SupportData>;

/**
 * Map of support contacts for each brand
 * 
 * Available fields:
 * - tg: Telegram bot username (without @)
 * - phone: Phone number for tel: link
 * - phoneText: Formatted phone number for display
 * - mail: Email address
 * - viber: Viber contact
 */
export const brandSupportMap: BrandSupportConfig = {
	default: {
		tg: 'PMKzSupport_bot',
		phone: '9933',
		phoneText: '9933',
		mail: 'support@parimatch.kz',
		viber: '9933'
	},
	nomad: {
		tg: 'NomadCasinoHelp_bot',
		phone: '77754730401',
		phoneText: '+7-775-473-04-01',
		mail: 'support@nomadgames.com'
	},
	ngu3: {
		mail: 'support@johnny24.bet'
	},
	blitz: {
		tg: 'KingCasinoSupport_bot'
	},
	com2: {
		mail: 'support@viphouse.com'
	},
	rockets: {
		tg: 'PMKzSupport_bot',
		phone: '9933',
		phoneText: '9933',
		mail: 'support@parimatch.kz'
	},
	rockets_vip: {
		tg: 'PMKzSupport_bot',
		phone: '9933',
		phoneText: '9933',
		mail: 'support@parimatch.kz'
	},
	sk2: {
		tg: 'PMKzSupport_bot',
		phone: '9933',
		phoneText: '9933',
		mail: 'support@parimatch.kz'
	}
};

/**
 * Get support contacts for the current brand
 * @returns SupportData - Support contacts for current brand
 */
export const getBrandSupport = (): SupportData => {
	const brand = config.BRAND || 'default';
	return brandSupportMap[brand] || brandSupportMap.default;
};

